export const makeEventSchema = (params) => {
    return {
        '@type': 'Event',
        name: params.title,
        startDate: params.startDate,
        endDate: params.endDate,
        description: params.description,
        image: params.image,
        url: params.siteUrl + '/event/' + params.url,
        location: {
            '@type': 'Place',
            name: params.eventLocationName,
            address: params.eventLocation,
        },
    };
};
